<template>
    <span v-if="reviews && dataLoaded">
        <span class="rating">
            <span class="blank">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
            </span>
            <span class="rate" style="width:0%" :style="'width:' + reviews.rating.replace(',','.') * 20 + '%'">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
            </span>
        </span>

        <strong class="t rate-count">{{ reviews.rating }} <span>{{ $translate("reviewWidget::Template.outof") }}</span> {{ reviews.userScore }}</strong>
        <span class="t txt">{{ $translate("reviewWidget::Template.summary2") }}</span>
    </span>
</template>

<script>
    export default {
        data: function() {
            return {
                reviews: [],
                dataLoaded: false
            }
        },
        mounted() {
            var self = this,
            reviews = [];

            $.getJSON('/rest/reviewWidget/get/summary').done(function( data ) {
                self.reviews = data;
                self.dataLoaded = true;

                var elems = document.querySelectorAll(".widget-review-cyt-badge .content");
                [].forEach.call(elems, function(el) {
                    el.classList.remove("loading");
                });
            })
        }
    }
</script>
